import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { LinkContainer } from 'react-router-bootstrap'
import Logo from '../images/logo-dark.svg'
import { Nav, NavDropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../store'
import { logout } from '../store/slices/app'
import useAuth from '../hooks/useAuth'
import Avatar from '../components/Avatar'
import Drawer from '../components/Drawer'
import { PageURLs } from '../common'

const Styles = {
  dropdown: {
    link: 'd-block cursor-pointer px-4 py-2 px-lg-5 text-secondary text-decoration-none',
  },
}

const Navigation = () => {
  const [mobileNavigationVisible, setMobileNavigationVisible] = useState(true)

  const history = useHistory()
  const currentLocation = useLocation()
  const dispatch = useDispatch()
  const auth = useAuth()
  const { user, authenticated } = useSelector((state: RootState) => state.app)
  useEffect(() => {
    setMobileNavigationVisible(false)
  }, [setMobileNavigationVisible, currentLocation.pathname])

  type MobileNavigationItem = { href: string; label: string }
  const MobileNavigationMenuItems: Array<MobileNavigationItem> = authenticated
    ? [
        { href: PageURLs.Transfers, label: 'My transfers' },
        { href: PageURLs.Billing, label: 'Billing' },
        { href: PageURLs.ProfileSettings, label: 'Settings' },
      ]
    : [
        { href: PageURLs.Login, label: 'Login' },
        { href: PageURLs.Register, label: 'Sign up' },
      ]

  MobileNavigationMenuItems.push(
    ...[
      { href: 'https://airportcars.com/help/', label: 'Help' },
      { href: 'https://airportcars.com/coverage-network/', label: 'Coverage' },
      { href: 'https://airportcars.com/company/', label: 'Company' },
    ]
  )

  const handleUserLogout = async () => {
    await auth.logout()
    dispatch(logout())
    setMobileNavigationVisible(false)
    history.push(PageURLs.Home)
  }

  return (
    <header className="banner site-header">
      <div className="container">
        <div className="row">
          <div className="col-4 col-sm-3 col-lg-2 d-flex align-items-center">
            <Link className="brand" to="/">
              <img src={Logo} className="mw-100" alt="Logo" />
            </Link>
          </div>

          <div className="col-5 d-none d-lg-block">
            <Nav className="nav-primary">
              {authenticated && (
                <>
                  <LinkContainer to={PageURLs.Transfers}>
                    <Nav.Link>My transfers</Nav.Link>
                  </LinkContainer>
                  <LinkContainer to={PageURLs.Billing}>
                    <Nav.Link>Billing</Nav.Link>
                  </LinkContainer>
                </>
              )}
              <Nav.Link href="https://airportcars.com/help/" target="_blank">
                Help
              </Nav.Link>
              <NavDropdown id="company-about" title="More">
                <NavDropdown.Item href="https://airportcars.com/coverage-network/" target="_blank">
                  Coverage Network
                </NavDropdown.Item>
                <NavDropdown.Item href="https://airportcars.com/company/" target="_blank">
                  Company
                </NavDropdown.Item>
                {/* <NavDropdown.Item href="/blog/">Blog</NavDropdown.Item> */}
              </NavDropdown>
            </Nav>
          </div>

          <div className="col-8 col-sm-9 col-lg-5 d-flex justify-content-end align-items-center">
            {authenticated === false && (
              <Link className="btn btn-outline-secondary ml-lg-3 mr-4 mr-lg-0 d-none d-lg-block" to="/login/">
                Log in / Sign Up
              </Link>
            )}
            {currentLocation.pathname !== PageURLs.BookNow && (
              <Link
                className="btn btn-secondary ml-lg-3 mr-4 mr-lg-0 btn-stripe d-none d-lg-block"
                to={PageURLs.BookNow}
              >
                Book a transfer
              </Link>
            )}
            {authenticated && (
              <>
                <div
                  className="position-relative ml-5"
                  onClick={() => setMobileNavigationVisible(!mobileNavigationVisible)}
                >
                  <Avatar user={user} />
                  <div
                    className={`profile-pic-dropdown position-absolute border border-secondary py-3 bg-white d-none ${
                      mobileNavigationVisible ? 'd-lg-block' : 'd-lg-none'
                    }`}
                    id="profile-pic-dropdown"
                  >
                    <ul className="list-unstyled mb-0">
                      <li className="dropdown-item p-0">
                        <Link to="/profile-settings/" className={Styles.dropdown.link}>
                          Settings
                        </Link>
                      </li>
                      <li className="dropdown-item p-0" onClick={handleUserLogout}>
                        <span className={Styles.dropdown.link}>Log out</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <Drawer
        visible={mobileNavigationVisible}
        onBackgroundClick={() => setMobileNavigationVisible(false)}
        className="mobile-navigation d-lg-none"
      >
        {authenticated && (
          <div className="avatar__wrapper">
            <Avatar user={user} className="avatar" />
            <span className="avatar__name">
              {user?.first_name} {user?.last_name}
            </span>
          </div>
        )}

        <div className="mobile-navigation__inner">
          <ul className="list-unstyled d-lg-none mb-0">
            {MobileNavigationMenuItems.map((link) => (
              <li className="dropdown-item p-0" key={`${link.href}-${link.label}`}>
                <Link to={link.href} className={Styles.dropdown.link}>
                  {link.label}
                </Link>
              </li>
            ))}
            {authenticated && (
              <li className="dropdown-item p-0" onClick={handleUserLogout}>
                <span className={Styles.dropdown.link}>Log out</span>
              </li>
            )}
          </ul>

          {currentLocation.pathname !== PageURLs.BookNow && (
            <Link className="btn btn-secondary btn-stripe mx-4" to={PageURLs.BookNow}>
              Book a transfer
            </Link>
          )}
        </div>
      </Drawer>
    </header>
  )
}

export default Navigation
